// extracted by mini-css-extract-plugin
export default {"overlay-modal":"right-modal_overlay-modal__g9dRl","modal":"right-modal_modal__KtD2Y"};